<script lang="ts">
    import {loader} from "./stores";

    export let force = false; // you can force the loading display in the component's call
    $: loading = $loader.loading;
    $: messages = $loader.messages;
</script>

<style lang="scss">
    #loader {
        width: 70%;
        position: absolute !important;
        transform: translateX(-50%) translateY(-50%);
        top: 50%;
        left: 50%;
        text-align: center;
        z-index: 9998;
    }
    #msg-container{
      width: 70%;
      position: absolute !important;
      top: 55%;
      left: 15%;
      text-align: center;
      z-index: 9999;
      .msg{
        color: white;
        font-weight: bold;
        font-size: 1.5rem;
        margin-bottom: 10px;
      }
    }
    #bg_loader {
        position: fixed;
        top:0;
        left: 0;
        width:100%;
        height: 100%;
        z-index: 9997;
        background-color: black;
        opacity: 0.7;
    }
</style>

{#if $loading || force}
    <div id="loader">
        <progress class="progress is-large is-orange" max="100">0%</progress>
    </div>
    <div id="msg-container">
        {#each $messages as msg}
            <div class="msg">{msg}</div>
        {/each}
    </div>
    <div id="bg_loader"></div>
{/if}

